import useNewsFeedFilters from "@/store/news-feed/filters/newsFeed-filter.slice";
import { useDynamicFilters } from "@/store/news-feed/filters/useDynamicFilters";
import { useAnalysisSidebarFilterParams } from "@/store/news-feed/params/analysis-params.context";
import NewsFeedFilterSectionWithSearch, {
  type DynamicFilterData,
} from "../NewsFeedFilterSectionWithSearch";
import ArticleTagFilterListItemMenu from "./ArticleTagsFilterMenu";

export const ArticleTagsFilterContainer = () => {
  const { toggleFilterSelection, selectedFilters } =
    useAnalysisSidebarFilterParams();

  const expandedCategories = useNewsFeedFilters(
    (state) => state.expandedCategories,
  );
  const setCategoryExpansion = useNewsFeedFilters(
    (state) => state.setCategoryExpansion,
  );

  const shouldFetchArticleTags =
    expandedCategories.has("FEED_ARTICLE_TAG") ||
    (selectedFilters.get("FEED_ARTICLE_TAG")?.length ?? 0) > 0;

  const {
    items: articleTags,
    isLoading: articleTagsLoading,
    error: articleTagsError,
  } = useDynamicFilters("FEED_ARTICLE_TAG", shouldFetchArticleTags);

  const filterData: DynamicFilterData = {
    items: articleTags,
    isLoading: articleTagsLoading,
    error: articleTagsError,
  };

  const isExpanded = expandedCategories.has("FEED_ARTICLE_TAG");

  return (
    // no-dd-sa:tsx-react/no-nested-components
    <NewsFeedFilterSectionWithSearch
      title="Tags"
      category="FEED_ARTICLE_TAG"
      filterData={filterData}
      selectedFilters={selectedFilters}
      showCount={false}
      labelTextWrap="wrap"
      isExpanded={isExpanded}
      visibleCount={10}
      onToggleFilter={toggleFilterSelection}
      onValueChange={(value) =>
        setCategoryExpansion("FEED_ARTICLE_TAG", value === "FEED_ARTICLE_TAG")
      }
      renderItemActions={(item) => <ArticleTagFilterListItemMenu item={item} />}
    />
  );
};
